import { useStaticContext } from './static-context.hook.js';
const webViewCookieRegex = /atwv=1/;
export const useNativeAppWebViewContext = () => {
    const staticContext = useStaticContext();
    let isWebView = false;
    if (staticContext.userAgent !== undefined) {
        isWebView = staticContext.userAgent.isWebView;
    }
    else if (typeof window !== 'undefined' && window.document !== undefined) {
        isWebView = window.document.cookie.match(webViewCookieRegex) !== null;
    }
    return { isWebView };
};
